import { IController, IDirective, INgModelController, IScope } from "angular";
import { SignatureComponentController } from "./controller";

export const vsDirectiveName = "signatureComponent";

function handlePointerDown(
  canvas: HTMLCanvasElement,
  ctx: CanvasRenderingContext2D,
  ngModelController: INgModelController,
  e: PointerEvent
) {
  ngModelController.$setDirty();
  ngModelController.$setTouched();

  canvas.dataset.writingMode = true.toString();

  const [positionX, positionY] = getCursorPosition(e);
  ctx.beginPath();
  ctx.moveTo(positionX, positionY);
}

function handlePointerUp(
  canvas: HTMLCanvasElement,
  ngModelController: INgModelController,
  e: PointerEvent
) {
  canvas.dataset.writingMode = false.toString();

  const imageUrl = canvas.toDataURL();
  ngModelController.$setViewValue(imageUrl);
}

function handlePointerMove(
  canvas: HTMLCanvasElement,
  ctx: CanvasRenderingContext2D,
  signatureComponentController: SignatureComponentController,
  e: PointerEvent
) {
  if (canvas.dataset.writingMode !== true.toString()) return;

  signatureComponentController.marked = true;

  const [positionX, positionY] = getCursorPosition(e);
  ctx.lineTo(positionX, positionY);
  ctx.stroke();
}

function handleClear(
  canvas: HTMLCanvasElement,
  ctx: CanvasRenderingContext2D,
  signatureComponentController: SignatureComponentController,
  ngModelController: INgModelController,
  e: Event
) {
  e.preventDefault();
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  signatureComponentController.marked = false;
  ngModelController.$setViewValue(canvas.toDataURL());
}

function getCursorPosition(e: PointerEvent) {
  const target = <Element>e.target;
  const positionX = e.clientX - target?.getBoundingClientRect().x;
  const positionY = e.clientY - target?.getBoundingClientRect().y;
  return [positionX, positionY];
}

export function SignatureDirective(): IDirective {
  return {
    template: require("!html-loader!./index.html").default,
    controller: SignatureComponentController,
    controllerAs: "signatureComponentController",
    require: [vsDirectiveName, "ngModel"],
    restrict: "E",
    bindToController: {
      marked: "=",
    },
    transclude: true,
    link: {
      post: (_, el, ___, badlyTypedControllers) => {
        const _controllers = <IController[]>badlyTypedControllers;
        const signatureComponentController = <SignatureComponentController>(
          _controllers[0]
        );

        const ngModelController = <INgModelController>_controllers[1];
        const canvas = <HTMLCanvasElement>el.find("canvas")[0];
        const button = <HTMLButtonElement>el.find("button")[0];
        const ctx = canvas.getContext("2d")!;

        signatureComponentController.marked = false;

        ctx.lineWidth = 3;
        ctx.lineJoin = ctx.lineCap = "round";

        canvas.dataset.writingMode = false.toString();

        ngModelController.$isEmpty = () => {
          const imgData = new Uint32Array(
            ctx.getImageData(0, 0, canvas.width, canvas.height).data.buffer
          );
          return imgData.some((color) => color !== 0);
        };

        button.addEventListener("click", (e: Event) =>
          handleClear(
            canvas,
            ctx,
            signatureComponentController,
            ngModelController,
            e
          )
        );

        canvas.addEventListener(
          "pointerdown",
          (e: PointerEvent) =>
            handlePointerDown(canvas, ctx, ngModelController, e),
          { passive: true }
        );
        canvas.addEventListener(
          "pointerup",
          (e: PointerEvent) => handlePointerUp(canvas, ngModelController, e),
          { passive: true }
        );
        canvas.addEventListener(
          "pointermove",
          (e: PointerEvent) =>
            handlePointerMove(canvas, ctx, signatureComponentController, e),
          {
            passive: true,
          }
        );
      },
    },
  };
}
